import { useEffect, useReducer } from 'react';
import { light, dark } from '../themes';
import { useClassList } from './generic/useClassList';
import { useDarkMode } from './generic/useDarkMode';

export const useThemeSwitcher = () => {
    const classes = useClassList(window.document.body);
    return classes.includes('themeSwitch');
};

export const getStoredTheme = () : 'light' | 'dark' | undefined => {
    const value = localStorage.getItem('theme');
    switch (value) {
        case 'dark': return 'dark';
        case 'light': return 'light';
        default: return undefined;
    }
};

export const setTheme = (theme: 'light' | 'dark' | undefined) => {
    // Because of browser that are trying to force style on the input fields,
    // within the css a prevention using transition is present.
    // However, this is prevents from switching theme properly. so first disable it.
    window.document.body.classList.add('themeSwitch');

    // Now we can switch theme safely
    if (theme) localStorage.setItem('theme', theme);
    else if (localStorage.getItem('theme') !== null) localStorage.removeItem('theme');
    window.dispatchEvent(new Event('storage'));

    // However, the transitions need to be disabled again else the browser problems are back again
    setTimeout(() => {
        window.document.body.classList.remove('themeSwitch');
    }, 100);
};

export const useSelectedTheme = () => {
    const browserDarkMode = useDarkMode();
    const [, forceUpdate] = useReducer(x => x + 1, 0);

    useEffect(() => {
        window.addEventListener('storage', forceUpdate);
        return () => window.removeEventListener('storage', forceUpdate);
    }, [forceUpdate]);

    const storageDarkMode = localStorage.getItem('theme');
    if (storageDarkMode === 'light') return light;
    if (storageDarkMode === 'dark') return dark;
    if (browserDarkMode) return dark;
    return light;
};
